const STORAGE_KEY = 'fluevog:recently-viewed';

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-recently-viewed-list]');
    this.cardSection = this.dataset.cardSection;
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.maxStored = parseInt(this.dataset.maxStored, 10) || 20;
    this.currentHandle = this.dataset.productHandle || null;

    const stored = this.readStore();
    const toRender = stored.filter((handle) => handle !== this.currentHandle).slice(0, this.limit);

    this.writeStore(stored);
    this.render(toRender);
  }

  readStore() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  writeStore(stored) {
    if (!this.currentHandle) return;
    const next = [this.currentHandle, ...stored.filter((handle) => handle !== this.currentHandle)].slice(
      0,
      this.maxStored
    );
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      /* ignore storage errors (private mode, quota) */
    }
  }

  async render(handles) {
    if (!handles.length || !this.list) {
      this.hidden = true;
      return;
    }

    try {
      const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
      const html = cards.filter(Boolean).join('');
      if (!html) {
        this.hidden = true;
        return;
      }
      this.list.innerHTML = html;
      this.hidden = false;
    } catch (error) {
      this.hidden = true;
    }
  }

  async fetchCard(handle) {
    const url = `${window.Shopify?.routes?.root || '/'}products/${handle}?section_id=${this.cardSection}`.replace(
      '//products',
      '/products'
    );
    const response = await fetch(url);
    if (!response.ok) return '';
    const markup = await response.text();
    // `resource-list__item` opts the card into the theme's equal-height card rules,
    // the same ones the collection grid items get.
    return markup.trim() ? `<li class="fv-rv-item resource-list__item">${markup}</li>` : '';
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
